import { ALL_VISITORS, E_COMMERCE_ID } from '@contentsquare/business-constants';
import { GoalClient, MappingClient, SegmentClient, ZoningClient } from '@contentsquare/uxanalytics-client';
import { from, ReplaySubject } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { Notifications } from '../constants/notifications';
import { ClientFactory } from './app.client.factory';
export var EntityType;
(function (EntityType) {
    EntityType["Goals"] = "goals";
    EntityType["Segments"] = "segments";
    EntityType["Mappings"] = "mappings";
    EntityType["Zonings"] = "zonings";
    EntityType["Zones"] = "zones";
})(EntityType || (EntityType = {}));
const entityClients = {
    [EntityType.Goals]: GoalClient,
    [EntityType.Segments]: SegmentClient,
    [EntityType.Mappings]: MappingClient,
    [EntityType.Zonings]: ZoningClient,
    [EntityType.Zones]: ZoningClient,
};
export class EntityService {
    constructor(projectId, config) {
        this.projectId = projectId;
        this.config = config;
        Object.values(EntityType).forEach((type) => {
            const subject = new ReplaySubject(1);
            EntityService.cache[type] = subject;
        });
    }
    get(entityType, addSyntheticEntities = false) {
        if (!EntityService.registeredListeners[entityType]) {
            const listener = ({ detail }) => {
                const entries = Object.entries(entityClients);
                const foundEntry = entries.find(([key, value]) => {
                    return value === detail;
                });
                if (foundEntry) {
                    this.onEntityChange(foundEntry[0]);
                }
            };
            window.addEventListener(Notifications.Crud, listener);
            EntityService.registeredListeners[entityType] = listener;
            this.onEntityChange(entityType);
        }
        const observable = EntityService.cache[entityType].pipe(finalize(() => {
            // Check that this is the last active observable in the list and will be removed after execution
            if (EntityService.cache[entityType].observers.length < 2) {
                window.removeEventListener(Notifications.Crud, EntityService.registeredListeners[entityType]);
                delete EntityService.registeredListeners[entityType];
                EntityService.cache[entityType] = new ReplaySubject(1);
            }
        }));
        return (addSyntheticEntities
            ? observable.pipe(map((entities) => this.extendArray(entities, entityType)))
            : observable);
    }
    onEntityChange(entityType) {
        from(this.request(entityType)).subscribe((result) => EntityService.cache[entityType].next(result));
    }
    async request(entityType) {
        const client = ClientFactory.get(entityClients[entityType]);
        if (client instanceof MappingClient) {
            return client.getAllWithPages(this.projectId, ['id', 'name'], ['id', 'name']);
        }
        switch (entityType) {
            case EntityType.Segments:
                return client.getAll(this.projectId, ['id', 'name']);
            case EntityType.Zones:
                return client.getZonesByProject(this.projectId, ['id', 'name', 'zoningId']);
            case EntityType.Zonings:
                return client.getZonings(this.projectId, ['id', 'name', 'device']);
            case EntityType.Goals:
                return client.getAll(this.projectId, ['id', 'name', 'type']);
            case EntityType.Mappings:
            default:
                return client.getAll(this.projectId, ['id', 'name']);
        }
    }
    // TODO: this might require basic translation engine to be part of core
    extendArray(result, entityType) {
        switch (entityType) {
            case EntityType.Segments:
                return [{ id: ALL_VISITORS, name: `All Visitors` }, ...result];
            case EntityType.Goals:
                return this.config.isEcommerce ? [{ id: E_COMMERCE_ID, name: `Ecommerce` }, ...result] : result;
            case EntityType.Mappings:
            default:
                return result;
        }
    }
}
EntityService.cache = {};
EntityService.registeredListeners = {};
//# sourceMappingURL=entity-service.js.map